import React, { memo } from 'react';
import { node } from 'prop-types';

import './HelperText.scss';

const HelperText = ({ children }) => (
  <span className="ThemedTextField__helperText">{children}</span>
);

HelperText.propTypes = {
  children: node,
};

export default memo(HelperText);
